import { PlacesListsService } from './placesLists.service';

export default angular
  .module('sfMobile.services.places-lists', [])
  .service('placesListsService', PlacesListsService).name;
